import { Descriptions } from "antd";
import dayjs from "dayjs";

const formatFee = (v: number) =>
  `LKR ${Number(v).toLocaleString(undefined, { minimumFractionDigits: 2 })}`;

const responsiveColumns = { xs: 1, sm: 2, md: 2, lg: 2 } as const;

export const OrderOverview = ({ order }: any) => {
  return (
    <>
      <Descriptions
        title="Overview"
        bordered
        size="small"
        column={responsiveColumns}
      >
        <Descriptions.Item label="Order No">
          <span className="font-bold">{order.order_no}</span>
        </Descriptions.Item>
        <Descriptions.Item label="Date & Time">
          {dayjs(order.order_date).format("YYYY-MM-DD HH:mm")}
        </Descriptions.Item>
        {order.delivery_date && (
          <Descriptions.Item label="Delivery Date">
            <span className="font-semibold text-cyan-700">
              {dayjs(order.delivery_date).format("YYYY-MM-DD")}
            </span>
          </Descriptions.Item>
        )}
        <Descriptions.Item label="Customer">
          {order.customer_name || "Walk-in Customer"}
        </Descriptions.Item>
        <Descriptions.Item label="Table">
          {order.table_name || "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Employee">
          {order.employee_name || "-"}
        </Descriptions.Item>
        <Descriptions.Item label="Store">{order.store_name}</Descriptions.Item>
        <Descriptions.Item label="Selling Type">
          <span className="capitalize">{order.selling_type}</span>
        </Descriptions.Item>
        <Descriptions.Item label="Cashier User">
          {order.username}
        </Descriptions.Item>
      </Descriptions>

      {order.courier_name && (
        <Descriptions
          title="Courier Details"
          bordered
          size="small"
          column={responsiveColumns}
          className="mt-4"
        >
          <Descriptions.Item label="Courier Name">
            {order.courier_name}
          </Descriptions.Item>
          <Descriptions.Item label="Status">
            <span className="capitalize">
              {order.courier_status || "assigned"}
            </span>
          </Descriptions.Item>
          {order.courier_tracking_no && (
            <Descriptions.Item label="Tracking No">
              {order.courier_tracking_no}
            </Descriptions.Item>
          )}
          {order.courier_delivery_fee != null && (
            <Descriptions.Item label="Delivery Fee">
              {formatFee(order.courier_delivery_fee)}
              <span className="text-[10px] text-gray-500 ml-1.5 capitalize">
                (Payer: {order.courier_fee_payer || "customer"})
              </span>
            </Descriptions.Item>
          )}
          {order.courier_is_cod === 1 && (
            <Descriptions.Item label="COD Amount" span={2}>
              {formatFee(order.courier_cod_amount)}
            </Descriptions.Item>
          )}
        </Descriptions>
      )}
    </>
  );
};